import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26c44542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left flex flex-col gap-1 bg-white p-4 rounded border shadow" }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-2 items-center mb-2 text-sm"
}
const _hoisted_3 = { class: "truncate col-span-1" }
const _hoisted_4 = { class: "flex gap-1 items-center" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold truncate text-right"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_7 = { class: "font-semibold truncate text-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "mb-8"
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "truncate",
  title: "Median"
}, "Median:", -1))
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = { class: "container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "truncate",
  title: "Confidence"
}, "Confidence:", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_18 = { class: "container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "truncate",
  title: "Lower limit"
}, "Lower limit:", -1))
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_22 = { class: "container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "truncate",
  title: "Lower limit"
}, "Upper limit:", -1))
const _hoisted_24 = ["title"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "truncate",
  title: "oculai"
}, "oculai:", -1))
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_29 = {
  key: 2,
  class: "container"
}
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_33 = {
  key: 3,
  class: "container"
}
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "font-semibold truncate text-right font-mono" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "ml-1 font-mono"
}
const _hoisted_39 = {
  key: 4,
  class: "container"
}
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "font-semibold truncate text-right font-mono" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "container border-t pt-1" }
const _hoisted_45 = { class: "truncate" }
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]

import { format } from "date-fns";
import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import numberService from "@/services/numberService";
import { UnitValue, UnitValueAggregate, UnitValueDetailField } from "@/types/UnitValue";
import { createFormatNumber } from "@/views/unit_values/services/unitValues";
import valueCellDetailCalculator from "@/views/unit_values/services/valueCellDetailCalculator";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValueCellDetail',
  props: {
  unitValue: {
    type: Object as PropType<UnitValue>,
    required: true,
  },
  unitValueAggregate: {
    type: Object as PropType<UnitValueAggregate>,
    required: false,
  },
  field: {
    type: String as PropType<UnitValueDetailField>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();

const formatNumber = createFormatNumber(useI18n().locale.value);
const decimalSeparator = numberService.getDecimalSeparator();

const fieldLabels: Record<UnitValueDetailField, string> = {
  duration: t("unit_values.duration_label"),
  workforce: t("unit_values.workforce_label"),
  value: t("unit_values.unit_value_label"),
};

const unitLabel = computed(() => {
  const labels: Record<UnitValueDetailField, string> = {
    duration: t("unit_values.duration_unit"),
    workforce: "",
    value: `${t("unit_values.unit_value_unit")}/${t(
      `unit_values.types.${props.unitValue.type}.unit`,
    )}`,
  };
  return labels[props.field];
});

const detail = computed(() => valueCellDetailCalculator(props.unitValue)[props.field]);

const formatNumberOrFallback = (value: number | null) =>
  formatNumber(value) ?? `-${decimalSeparator}--`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.unitValue.actual_start || __props.unitValue.actual_end)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("buttons.time_range")) + ":", 1),
          _createElementVNode("div", _hoisted_4, [
            (__props.unitValue.actual_start)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(format)(__props.unitValue.actual_start, "dd.MM.yy")), 1))
              : _createCommentVNode("", true),
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.unitValue.actual_end
              ? _unref(format)(__props.unitValue.actual_end, "dd.MM.yy")
              : _ctx.$t("analytics.reports.present")), 1),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.unitValueAggregate && __props.field === 'value' && _ctx.hasPermission('app_admin'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", {
              class: "font-semibold truncate text-right font-mono",
              title: formatNumberOrFallback(__props.unitValueAggregate.quantile_50th)
            }, _toDisplayString(formatNumberOrFallback(__props.unitValueAggregate.quantile_50th)), 9, _hoisted_12),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", {
              class: "font-semibold truncate text-right font-mono",
              title: formatNumberOrFallback(__props.unitValueAggregate.confidence)
            }, _toDisplayString(formatNumberOrFallback(__props.unitValueAggregate.confidence)), 9, _hoisted_16),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", {
              class: "font-semibold truncate text-right font-mono",
              title: formatNumberOrFallback(__props.unitValueAggregate.confidence_lower_limit)
            }, _toDisplayString(formatNumberOrFallback(__props.unitValueAggregate.confidence_lower_limit)), 9, _hoisted_20),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", {
              class: "font-semibold truncate text-right font-mono",
              title: formatNumberOrFallback(__props.unitValueAggregate.confidence_upper_limit)
            }, _toDisplayString(formatNumberOrFallback(__props.unitValueAggregate.confidence_upper_limit)), 9, _hoisted_24),
            _hoisted_25
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { 'line-through': detail.value.oculai !== detail.value.oculai_adjusted }])
    }, [
      _hoisted_26,
      _createElementVNode("span", {
        class: "font-semibold truncate text-right font-mono",
        title: formatNumberOrFallback(detail.value.oculai)
      }, _toDisplayString(formatNumberOrFallback(detail.value.oculai)), 9, _hoisted_27),
      _hoisted_28
    ], 2),
    (detail.value.oculai !== detail.value.oculai_adjusted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("span", {
            class: "truncate",
            title: _ctx.$t('unit_values.detail_oculai_new_calculated')
          }, _toDisplayString(_ctx.$t("unit_values.detail_oculai_new_calculated")) + ":", 9, _hoisted_30),
          _createElementVNode("span", {
            class: "font-semibold truncate text-right font-mono",
            title: formatNumberOrFallback(detail.value.oculai_adjusted)
          }, _toDisplayString(formatNumberOrFallback(detail.value.oculai_adjusted)), 9, _hoisted_31),
          _hoisted_32
        ]))
      : _createCommentVNode("", true),
    (detail.value.type_adjustment !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("span", {
            class: "truncate",
            title: _ctx.$t('unit_values.detail_delta_label')
          }, _toDisplayString(_ctx.$t("unit_values.detail_delta_label")) + ":", 9, _hoisted_34),
          _createElementVNode("span", _hoisted_35, [
            (detail.value.type_adjustment_difference !== null && detail.value.type_adjustment_difference > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "+"))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              title: formatNumberOrFallback(detail.value.type_adjustment_difference)
            }, _toDisplayString(formatNumberOrFallback(detail.value.type_adjustment_difference)), 9, _hoisted_37)
          ]),
          (__props.field === 'duration' && __props.unitValue.type_duration_factor !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(" + _toDisplayString(formatNumberOrFallback(__props.unitValue.type_duration_factor * 100)) + "%)", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (detail.value.custom_value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("span", {
            class: "truncate",
            title: _ctx.$t('unit_values.detail_custom_delta_label')
          }, _toDisplayString(_ctx.$t("unit_values.detail_custom_delta_label")) + ":", 9, _hoisted_40),
          _createElementVNode("span", _hoisted_41, [
            (detail.value.custom_value_difference !== null && detail.value.custom_value_difference > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "+"))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              title: formatNumberOrFallback(detail.value.custom_value_difference)
            }, _toDisplayString(formatNumberOrFallback(detail.value.custom_value_difference)), 9, _hoisted_43)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("span", _hoisted_45, _toDisplayString(fieldLabels[__props.field]) + ":", 1),
      _createElementVNode("span", {
        class: "font-semibold truncate text-right font-mono",
        title: formatNumberOrFallback(detail.value.final_value)
      }, _toDisplayString(formatNumberOrFallback(detail.value.final_value)), 9, _hoisted_46),
      _createElementVNode("span", {
        class: "truncate font-semibold ml-1 font-mono",
        title: unitLabel.value
      }, _toDisplayString(unitLabel.value), 9, _hoisted_47)
    ])
  ]))
}
}

})